import { Button } from '@cian/ui-kit/button';
import { Link } from '@cian/ui-kit/link';
import { Fragment, useState } from 'react';

import type { IPhone } from 'shared/types/phone';
import { formatPhone, getPhoneLink } from 'shared/utils/phone';

import style from './style.css';

export interface IPhoneButtonProps {
  phones: IPhone[];
  /** Плавающая шапка: один номер крупнее, два — мельче (`object_phone_show.css` монолита) */
  isCompact?: boolean;
}

/**
 * Кнопка «Показать телефон(ы)», по клику заменяется номерами — `ObjectPhoneShow` + `RevealContent` монолита.
 * Состояние у каждого экземпляра своё
 */
export const PhoneButton = ({ phones, isCompact = false }: IPhoneButtonProps) => {
  const [isShown, setIsShown] = useState(false);

  if (!phones.length) {
    return null;
  }

  const handleReveal = () => {
    setIsShown(true);
    // @todo: добавить аналитику как в монолите
  };

  if (!isShown) {
    return (
      <div data-name="PhoneButton">
        <Button theme="main_primary" size="XS" onClick={handleReveal}>
          {phones.length > 1 ? 'Показать телефоны' : 'Показать телефон'}
        </Button>
      </div>
    );
  }

  const fontSize = isCompact && phones.length > 1 ? 'S' : 'M';

  return (
    <div className={isCompact ? style['compact'] : undefined} data-name="Phones">
      {phones.map((phone, index) => (
        <Fragment key={`${phone.countryCode}${phone.number}`}>
          {index > 0 && ', '}
          <Link href={getPhoneLink(phone)} fontSize={isCompact ? fontSize : undefined}>
            {formatPhone(phone)}
          </Link>
        </Fragment>
      ))}
    </div>
  );
};
